/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufEmpty from '../../../google/protobuf/empty.pb';
import * as EdukitaPaulaBackendCommonFilter from '../common/filter.pb';
import * as EdukitaPaulaBackendGaragecacheEntities from '../garagecache/entities.pb';
import * as EdukitaPaulaBackendGaragecacheProfiles from '../garagecache/profiles.pb';
import * as EdukitaPaulaBackendV3LevelTrackerService from './level_tracker_service.pb';
import * as fm from '@generated/fetch.pb';

export type StudentTracker = {
    studentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageStudentProfile;
    parentProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageParentProfile;
    subscriptionStatus?: EdukitaPaulaBackendGaragecacheEntities.StudentSubscriptionStatusView;
    academicMonth?: string;
    levelTracker?: EdukitaPaulaBackendV3LevelTrackerService.LevelTracker;
};

export type GetStudentTrackersRequest = {
    academicMonth?: string;
    garageStudentId?: number;
    garageLevelLabels?: string[];
    garageParentName?: string;
    garageStudentName?: string;
    garageTeacherIds?: number[];
    attendanceNeedAttention?: string;
    flagToParentNeedAttention?: string;
    garagePartnerId?: number;
    tenureMonth?: number;
    page?: number;
    pageSize?: number;
    subscriptionStatus?: string;
};

export type GetStudentTrackersResponse = {
    studentTrackers?: StudentTracker[];
    totalCount?: number;
    page?: number;
    pageSize?: number;
};

export type GetStudentTrackerFiltersResponse = {
    filters?: EdukitaPaulaBackendCommonFilter.FilterDefinition[];
};

export class StudentTrackerService {
    static GetStudentTrackers(
        this: void,
        req: GetStudentTrackersRequest,
        initReq?: fm.InitReq
    ): Promise<GetStudentTrackersResponse> {
        return fm.fetchRequest<GetStudentTrackersResponse>(
            `/v3/student-trackers?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetStudentTrackerFilters(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<GetStudentTrackerFiltersResponse> {
        return fm.fetchRequest<GetStudentTrackerFiltersResponse>(
            `/v3/student-trackers/filters?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
}
